import { RuntimeConfiguration } from '@/configuration';

/**
 * Converts Ethereum (ETH) value to a price, applying rounding and buffer adjustments.
 *
 * @param ethValue - The input Ethereum value as a string.
 * @returns A string representing the adjusted ETH price after applying rounding and buffer values.
 */

// Retrieve configuration values for buffer and rounding
const bufferValue = parseFloat(RuntimeConfiguration.BUFFER_VALUE);
const roundingValue = parseFloat(RuntimeConfiguration.ROUND_OF_VALUE);

export const ethPriceConversion = async (ethValue: string): Promise<string> => {
  // Parse and round the input Ethereum value to 5 decimal places
  const parsedEthValue = parseFloat(ethValue).toFixed(5);

  // Apply rounding to the parsed Ethereum value
  const adjustedEthValue = parseFloat(parsedEthValue) + roundingValue;

  // Calculate the actual ETH price after applying the buffer
  const ethActualPrice = adjustedEthValue + adjustedEthValue * bufferValue;

  // Round the final price to 5 decimal places
  const finalEthPrice = ethActualPrice.toFixed(5);

  return finalEthPrice;
};
